import App from '@/App';
import { SessionProvider } from '@/hooks/use-session';
import { SiteProvider } from '@/hooks/use-site';
import '@/index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

/**
 * Point d'entrée de l'application.
 *
 * L'imbrication des fournisseurs n'est pas arbitraire :
 *
 * 1. `BrowserRouter` en premier — les contextes situés en dessous peuvent
 *    ainsi utiliser la navigation ;
 * 2. `SiteProvider` ensuite — il déclenche `GET /site`, le premier appel du
 *    site, et conditionne l'affichage de tout le reste ;
 * 3. `SessionProvider` enfin — il vérifie le token éventuellement présent
 *    dans le stockage local.
 *
 * `StrictMode` monte puis remonte chaque composant en développement, afin de
 * révéler les effets mal nettoyés. C'est volontairement conservé : le code de
 * cet exemple doit y survivre. C'est la raison de la garde `paymentRequested`
 * dans le tunnel de paiement — sans elle, `POST /payment` partirait deux fois
 * en développement.
 */
const container = document.getElementById('root');

if (!container) {
    throw new Error("L'élément #root est introuvable dans index.html.");
}

createRoot(container).render(
    <StrictMode>
        <BrowserRouter>
            <SiteProvider>
                <SessionProvider>
                    <App />
                </SessionProvider>
            </SiteProvider>
        </BrowserRouter>
    </StrictMode>,
);
